import { css } from "styled-components"

export const axisVertical = css`
  position: absolute;
  left: 50%;
  margin-left: -1px;
  margin-right: -1px;
  width: 2px;
  content: "";
  background-color: ${props => props.theme.color.area};
  top: auto;
  bottom: 0;
`

export const axisHorizontal = css`
  position: absolute;
  top: 50%;
  margin-top: -1px;
  margin-bottom: -1px;
  height: 2px;
  background-color: ${props => props.theme.color.area};
`

export const transferFinishedOutline = css`
  box-shadow: ${props => props.theme.boxShadow},
    inset 0 0 0 1px ${props => props.theme.color.valid};
`

export const fullSizeBubbleContent = css`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  border-radius: 50%;
  width: 100%;
`
